(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["wuyin-collection"]) return;
  try {
    
(() => {
  if (customElements.get('wuyin-collection')) return;
  customElements.define('wuyin-collection', class extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('[data-wyc-form]');
      if (!this.form || this.bound) return;
      this.bound = true;
      this.onFormData = (event) => {
        this.form.querySelectorAll('[data-wyc-price]').forEach((input) => {
          if (input.value.trim() === '') event.formData.delete(input.name);
        });
      };
      this.form.addEventListener('formdata', this.onFormData);
    }
    disconnectedCallback() {
      if (!this.form || !this.bound) return;
      this.form.removeEventListener('formdata', this.onFormData);
      this.bound = false;
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wuyin-homepage"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('wuyin-homepage')) return;
  class WuyinHomepage extends HTMLElement {
    connectedCallback() { this.init(); }
    disconnectedCallback() { this.destroy(); }
    init() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.slides = Array.from(this.querySelectorAll('[data-edition]'));
      this.index = 0;
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.dataset.autoplay !== 'true' || this.reduced.matches;
      this.visible = false;
      this.changed = Date.now();
      this.querySelector('[data-edition-controls]')?.removeAttribute('hidden');
      this.querySelector('[data-filters]')?.removeAttribute('hidden');
      this.addEventListener('click', event => this.onClick(event), { signal });
      this.addEventListener('focusin', event => {
        if (event.target.closest('[data-editions]') && event.target.matches(':focus-visible')) { this.paused = true; this.updatePause(); }
      }, { signal });
      this.reduced.addEventListener('change', event => { if (event.matches) { this.paused = true; this.updatePause(); } }, { signal });
      const carousel = this.querySelector('[data-editions]');
      if (carousel) {
        this.observer = new IntersectionObserver(entries => {
          const visible = entries[0].isIntersecting;
          if (visible !== this.visible) this.changed = Date.now();
          this.visible = visible;
        });
        this.observer.observe(carousel);
      }
      this.showEdition(0);
      this.countdownUpdated = Date.now();
      this.timer = setInterval(() => {
        const now = Date.now();
        if (document.hidden || !this.visible) { this.changed = now; return; }
        if (now - this.countdownUpdated >= 1000) { this.updateCountdown(); this.countdownUpdated = now; }
        if (this.slides.length > 1 && !this.paused && now - this.changed >= 3000) this.showEdition(this.index + 1);
      }, 250);
    }
    destroy() {
      this.controller?.abort();
      this.controller = null;
      clearInterval(this.timer);
      this.observer?.disconnect();
    }
    updatePause() {
      const button = this.querySelector('[data-edition-pause]');
      if (button) button.textContent = this.paused ? this.dataset.playLabel : this.dataset.pauseLabel;
    }
    showEdition(index, announce = false) {
      if (!this.slides.length) return;
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => { slide.hidden = i !== this.index; });
      this.querySelectorAll('[data-edition-index]').forEach(button => button.setAttribute('aria-current', String(Number(button.dataset.editionIndex) === this.index)));
      this.changed = Date.now();
      this.updatePause();
      this.updateCountdown();
      if (announce) this.querySelector('[data-edition-status]').textContent = this.slides[this.index].getAttribute('aria-label');
    }
    updateCountdown() {
      const slide = this.slides[this.index];
      if (!slide) return;
      const label = slide.querySelector('[data-launch-state]');
      const timer = slide.querySelector('[data-countdown]');
      const date = slide.querySelector('[data-launch-date]');
      const source = slide.dataset.launch;
      const showSchedule = slide.dataset.countdownEnabled === 'true';
      label.hidden = !showSchedule;
      date.hidden = !showSchedule;
      timer.hidden = true;
      if (!showSchedule) return;
      const zoned = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2})?(?:Z|[+-]\d{2}:\d{2})$/.test(source);
      const timestamp = zoned ? Date.parse(source) : NaN;
      const valid = Number.isFinite(timestamp);
      timer.hidden = true;
      if (!valid) {
        label.textContent = this.dataset.unannouncedLabel;
        date.hidden = true;
        timer.hidden = false;
        timer.setAttribute('role', 'group');
        timer.querySelectorAll('[data-unit]').forEach(unit => { unit.textContent = '—'; });
        return;
      }
      timer.setAttribute('role', 'timer');
      date.textContent = new Intl.DateTimeFormat(document.documentElement.lang || 'en', { timeZone: this.dataset.timeZone, timeZoneName: 'short', year: 'numeric', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false }).format(timestamp);
      const seconds = Math.max(0, Math.ceil((timestamp - Date.now()) / 1000));
      if (seconds === 0) { label.textContent = this.dataset.demo === 'true' ? this.dataset.demoStartedLabel : (slide.dataset.productAvailable === 'true' ? this.dataset.availableLabel : this.dataset.startedLabel); return; }
      if (slide.dataset.countdownEnabled !== 'true') { label.textContent = this.dataset.upcomingLabel; return; }
      label.textContent = this.dataset.countdownLabel;
      timer.hidden = false;
      const values = [Math.floor(seconds / 86400), Math.floor(seconds / 3600) % 24, Math.floor(seconds / 60) % 60, seconds % 60];
      timer.querySelectorAll('[data-unit]').forEach(unit => { unit.textContent = String(values[Number(unit.dataset.unit)]).padStart(2, '0'); });
    }
    showWorld(id) {
      const target = this.querySelector(`[data-world-panel="${CSS.escape(id)}"]`);
      if (!target) return;
      this.querySelectorAll('[data-world-panel]').forEach(panel => { panel.hidden = panel !== target; });
      this.querySelectorAll('[data-world-target]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.worldTarget === id)));
    }
    filterWorks(group) {
      const panel = this.querySelector(`[data-work-panel="${CSS.escape(group)}"]`);
      if (!panel) return;
      this.querySelectorAll('[data-work-panel]').forEach(item => { item.hidden = item !== panel; });
      this.querySelectorAll('[data-filter]').forEach(control => control.setAttribute(control.tagName === 'A' ? 'aria-current' : 'aria-pressed', String(control.dataset.filter === group)));
      panel.querySelector('[data-work-grid]')?.scrollTo({ left: 0, behavior: 'auto' });
      const active = this.querySelector(`[data-filter="${CSS.escape(group)}"]`);
      const status = this.querySelector('[data-filter-status]');
      if (status && active) status.textContent = `${active.textContent}: ${panel.querySelectorAll('.wyhp-product').length}`;
    }
    onClick(event) {
      const filter = event.target.closest('[data-filter]');
      if (filter && this.contains(filter)) {
        if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        this.filterWorks(filter.dataset.filter);
        return;
      }
      const button = event.target.closest('button');
      if (!button || !this.contains(button)) return;
      if (button.hasAttribute('data-edition-index') || button.hasAttribute('data-edition-step')) {
        this.paused = true;
        this.showEdition(button.hasAttribute('data-edition-index') ? Number(button.dataset.editionIndex) : this.index + Number(button.dataset.editionStep), true);
      }
      if (button.hasAttribute('data-edition-pause')) { this.paused = !this.paused; this.changed = Date.now(); this.updatePause(); }
      if (button.dataset.worldTarget) this.showWorld(button.dataset.worldTarget);
    }
    selectBlock(id) {
      const slideIndex = this.slides.findIndex(slide => slide.dataset.blockId === id);
      if (slideIndex >= 0) { this.paused = true; this.showEdition(slideIndex); }
      this.showWorld(id);

    }
  }
  customElements.define('wuyin-homepage', WuyinHomepage);
  document.addEventListener('shopify:section:load', event => { event.target.querySelectorAll('wuyin-homepage').forEach(element => element.init()); });
  document.addEventListener('shopify:section:unload', event => { event.target.querySelectorAll('wuyin-homepage').forEach(element => element.destroy()); });
  document.addEventListener('shopify:block:select', event => {
    const element = event.target.closest('wuyin-homepage');
    if (element && event.detail?.blockId) element.selectBlock(event.detail.blockId);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wuyin-materials-care"]) return;
  try {
    
if (!customElements.get('wuyin-care-guide')) {
  customElements.define('wuyin-care-guide', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.materialButtons = Array.from(this.querySelectorAll('[data-wym-material]'));
      this.concernButtons = Array.from(this.querySelectorAll('[data-wym-concern]'));
      this.result = this.querySelector('.wym-result');
      this.material = this.materialButtons[0]?.dataset.wymMaterial;
      this.concern = 'everyday';
      if (!this.material || !this.result) return;
      [...this.materialButtons, ...this.concernButtons].forEach(button => { button.disabled = false; });
      this.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button || !this.contains(button)) return;
        if (button.dataset.wymMaterial) this.material = button.dataset.wymMaterial;
        else if (button.dataset.wymConcern) this.concern = button.dataset.wymConcern;
        else return;
        this.update();
      });
      this.addEventListener('shopify:block:select', event => {
        const button = event.target.closest('[data-wym-material]');
        if (button) { this.material = button.dataset.wymMaterial; this.update(); }
      });
    }
    update() {
      const template = Array.from(this.querySelectorAll('template[data-wym-result]')).find(item => item.dataset.wymResult === this.material + ':' + this.concern);
      if (!template) return;
      this.materialButtons.forEach(button => {
        const active = button.dataset.wymMaterial === this.material;
        button.setAttribute('aria-pressed', String(active));
        button.querySelector('b').textContent = active ? '✓' : '+';
      });
      this.concernButtons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.wymConcern === this.concern)));
      this.result.replaceChildren(template.content.cloneNode(true));
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wuyin-product-admin-managed"]) return;
  try {
    
(function () {
  'use strict';

  var ROOT_SELECTOR = '[data-wp-product]';
  var BOUND = Symbol.for('wuyin.product.bound');
  var SECTION_EVENTS = Symbol.for('wuyin.product.sectionEvents');

  function rootsWithin(scope) {
    var roots = Array.from(scope.querySelectorAll(ROOT_SELECTOR));
    if (scope.matches && scope.matches(ROOT_SELECTOR)) roots.unshift(scope);
    return roots;
  }

  function initialize(root) {
    if (root[BOUND]) return;
    var abort = new AbortController();
    var signal = abort.signal;
    root.addEventListener('click', function (event) {
      var link = event.target.closest('.wp-story-link, .wp-final-details');
      if (!link || !root.contains(link)) return;
      var target = document.getElementById(link.hash.slice(1));
      if (!target || !root.contains(target)) return;
      event.preventDefault();
      event.stopPropagation();
      if (link.classList.contains('wp-final-details')) {
        var details = target.querySelector('details');
        if (details) details.open = true;
      }
      target.scrollIntoView({ block: 'start', behavior: 'instant' });
    }, { signal: signal });
    var stickyObserver = null;
    root[BOUND] = function () {
      abort.abort();
      if (stickyObserver) stickyObserver.disconnect();
      delete root[BOUND];
    };

    var gallery = root.querySelector('[data-wp-gallery]');
    var slides = Array.from(root.querySelectorAll('.wp-slide[data-media-id]'));
    var indices = Array.from(root.querySelectorAll('[data-wp-index]'));
    var steps = Array.from(root.querySelectorAll('[data-wp-step]'));
    var counts = Array.from(root.querySelectorAll('[data-wp-count]'));
    var form = root.querySelector('[data-wp-form]');
    var variantSelect = form && form.querySelector('select[name="id"]');
    var quantities = Array.from(root.querySelectorAll('[data-wp-quantity]'));
    var submitButtons = Array.from(root.querySelectorAll('[data-wp-submit]'));
    var sticky = root.querySelector('[data-wp-sticky]');
    var dialog = root.querySelector('dialog[data-wp-dialog]');
    var dialogImage = dialog && dialog.querySelector('img');
    var returnFocus = null;
    var gesture = null;
    var suppressClickUntil = 0;
    var current = slides.findIndex(function (slide) {
      return slide.dataset.mediaId === root.dataset.initialMedia;
    });
    if (current < 0) current = slides.findIndex(function (slide) { return !slide.hidden; });
    if (current < 0) current = 0;

    function pauseSlide(slide) {
      slide.querySelectorAll('video').forEach(function (video) { video.pause(); });
      slide.querySelectorAll('iframe').forEach(function (frame) {
        var src = frame.getAttribute('src');
        if (!src || src === 'about:blank') return;
        var pausedURL = new URL(src, window.location.href);
        pausedURL.searchParams.set('autoplay', '0');
        frame.setAttribute('src', pausedURL.href);
      });
    }

    function showSlide(index) {
      if (!slides.length) return;
      var next = ((index % slides.length) + slides.length) % slides.length;
      if (next !== current) pauseSlide(slides[current]);
      current = next;
      slides.forEach(function (slide, slideIndex) {
        slide.hidden = slideIndex !== current;
        slide.setAttribute('aria-hidden', slideIndex === current ? 'false' : 'true');
      });
      indices.forEach(function (button) {
        button.setAttribute('aria-pressed', Number(button.dataset.wpIndex) === current ? 'true' : 'false');
      });
      var thumbnail = root.querySelector('.wp-thumbnail[aria-pressed="true"]');
      if (thumbnail && thumbnail.offsetWidth) {
        var strip = thumbnail.parentElement;
        var thumbnailRect = thumbnail.getBoundingClientRect();
        var stripRect = strip.getBoundingClientRect();
        if (window.getComputedStyle(strip).flexDirection === 'column') {
          strip.scrollTop += thumbnailRect.top - stripRect.top - (strip.clientHeight - thumbnailRect.height) / 2;
        } else {
          strip.scrollLeft += thumbnailRect.left - stripRect.left - (strip.clientWidth - thumbnailRect.width) / 2;
        }
      }
      counts.forEach(function (count) {
        count.textContent = String(current + 1) + ' / ' + String(slides.length);
      });
    }

    steps.forEach(function (button) {
      button.type = 'button';
      button.hidden = slides.length < 2;
      button.addEventListener('click', function () {
        showSlide(current + Number(button.dataset.wpStep));
      }, { signal: signal });
    });
    indices.forEach(function (button) {
      button.type = 'button';
      button.hidden = slides.length < 2;
      button.addEventListener('click', function () {
        showSlide(Number(button.dataset.wpIndex));
      }, { signal: signal });
    });
    counts.forEach(function (count) { count.hidden = slides.length < 2; });
    showSlide(current);

    if (gallery) {
      if (!gallery.hasAttribute('tabindex')) gallery.tabIndex = 0;
      gallery.style.touchAction = 'pan-y pinch-zoom';
      gallery.addEventListener('keydown', function (event) {
        if (event.altKey || event.ctrlKey || event.metaKey || slides.length < 2) return;
        if (event.target.closest('input, select, textarea, [contenteditable]:not([contenteditable="false"])')) return;
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        showSlide(current + (event.key === 'ArrowRight' ? 1 : -1));
      }, { signal: signal });

      gallery.addEventListener('dragstart', function (event) {
        if (event.target.closest('.wp-slide')) event.preventDefault();
      }, { signal: signal });

      gallery.addEventListener('pointerdown', function (event) {
        if (!slides.length || !event.isPrimary || event.button !== 0) return;
        var control = event.target.closest('button, a, input, select, textarea, video, iframe, [contenteditable]');
        if (control && !control.matches('[data-wp-zoom]')) return;
        gesture = { id: event.pointerId, type: event.pointerType, x: event.clientX, y: event.clientY, axis: null };
      }, { signal: signal });

      gallery.addEventListener('pointermove', function (event) {
        if (!gesture || event.pointerId !== gesture.id) return;
        var dx = event.clientX - gesture.x;
        var dy = event.clientY - gesture.y;
        if (!gesture.axis && Math.max(Math.abs(dx), Math.abs(dy)) > 12) {
          if (Math.abs(dx) > Math.abs(dy) * 1.3) {
            gesture.axis = 'x';
            gallery.setPointerCapture(event.pointerId);
          } else if (Math.abs(dy) > Math.abs(dx)) {
            gesture.axis = 'y';
          }
        }
        if (gesture.axis === 'x' && event.cancelable) event.preventDefault();
      }, { signal: signal, passive: false });

      function finishGesture(event) {
        if (!gesture || event.pointerId !== gesture.id) return;
        var completed = gesture;
        gesture = null;
        if (gallery.hasPointerCapture(event.pointerId)) gallery.releasePointerCapture(event.pointerId);
        var dx = event.clientX - completed.x;
        var dy = event.clientY - completed.y;
        if (completed.axis !== 'x') {
          if (completed.type === 'mouse' && Math.max(Math.abs(dx), Math.abs(dy)) > 12) {
            suppressClickUntil = Date.now() + 450;
          }
          return;
        }
        suppressClickUntil = Date.now() + 450;
        if (event.type === 'pointercancel') return;
        var threshold = Math.min(64, Math.max(36, gallery.clientWidth * 0.09));
        if (Math.abs(dx) >= threshold && Math.abs(dx) > Math.abs(dy) * 1.3) {
          showSlide(current + (dx < 0 ? 1 : -1));
        }
      }

      gallery.addEventListener('pointerup', finishGesture, { signal: signal });
      gallery.addEventListener('pointercancel', finishGesture, { signal: signal });
      gallery.addEventListener('click', function (event) {
        if (Date.now() >= suppressClickUntil) return;
        event.preventDefault();
        event.stopImmediatePropagation();
      }, { signal: signal, capture: true });
    }

    if (dialog && dialogImage) {
      root.querySelectorAll('[data-wp-zoom]').forEach(function (button) {
        if (button.tagName === 'BUTTON') button.type = 'button';
      });
      root.addEventListener('click', function (event) {
        var button = event.target.closest('[data-wp-zoom]');
        if (!button || !root.contains(button)) return;
        var source = button.dataset.zoomSrc;
        if (!source) return;
        event.preventDefault();
        returnFocus = button;
        dialogImage.src = source;
        dialogImage.alt = button.dataset.zoomAlt || '';
        if (!dialog.open) dialog.showModal();
        var closeButton = dialog.querySelector('[data-wp-close]');
        if (closeButton) closeButton.focus({ preventScroll: true });
      }, { signal: signal });
      dialog.querySelectorAll('[data-wp-close]').forEach(function (button) {
        button.type = 'button';
        button.addEventListener('click', function () { dialog.close(); }, { signal: signal });
      });
      dialog.addEventListener('click', function (event) {
        if (event.target === dialog) dialog.close();
      }, { signal: signal });
      dialog.addEventListener('close', function () {
        if (returnFocus && returnFocus.isConnected) returnFocus.focus({ preventScroll: true });
        returnFocus = null;
      }, { signal: signal });
    }

    function positiveInteger(value, fallback) {
      var parsed = Number(value);
      return Number.isFinite(parsed) && parsed > 0 ? Math.floor(parsed) : fallback;
    }

    function normalizeQuantity(input) {
      var min = positiveInteger(input.min, 1);
      var step = positiveInteger(input.step, 1);
      var max = input.max === '' ? Infinity : positiveInteger(input.max, Infinity);
      var value = positiveInteger(input.value, min);
      var increments = Math.max(0, Math.round((value - min) / step));
      if (Number.isFinite(max)) increments = Math.min(increments, Math.max(0, Math.floor((max - min) / step)));
      input.value = String(min + increments * step);
    }

    function updateButtons(available) {
      var comingSoon = root.dataset.isComingSoon === 'true';
      var label = comingSoon
        ? (root.dataset.comingSoonLabel || 'Coming soon')
        : available
          ? (root.dataset.addLabel || 'Add to bag')
          : (root.dataset.soldOutLabel || 'Sold out');
      submitButtons.forEach(function (button) {
        button.disabled = comingSoon || !available;
        var labelElement = button.querySelector('[data-wp-label]');
        if (labelElement) labelElement.textContent = label;
        else button.textContent = label;
        button.querySelectorAll('[data-wp-buy-price]').forEach(function (price) {
          price.hidden = comingSoon || !available;
        });
      });
    }

    function updateVariant(userChange) {
      if (!variantSelect) return;
      var option = variantSelect.options[variantSelect.selectedIndex];
      if (!option) return;
      if (option.dataset.material !== undefined) {
        root.querySelectorAll('[data-wp-material]').forEach(function (material) {
          material.textContent = option.dataset.material;
        });
      }
      root.querySelectorAll('[data-wp-price]').forEach(function (price) {
        if (option.dataset.price !== undefined) price.textContent = option.dataset.price;
      });
      if (option.dataset.priceAmount !== undefined) {
        root.querySelectorAll('[data-wp-price-amount], [data-wp-buy-amount]').forEach(function (amount) {
          amount.textContent = option.dataset.priceAmount;
        });
      }
      root.querySelectorAll('[data-wp-compare]').forEach(function (price) {
        var compare = option.dataset.compare || '';
        price.textContent = compare;
        price.hidden = compare.trim() === '';
      });
      updateButtons(option.dataset.available === 'true');
      quantities.forEach(function (input) {
        input.min = String(positiveInteger(option.dataset.quantityMin, 1));
        input.step = String(positiveInteger(option.dataset.quantityIncrement, 1));
        if (input.closest('.wp-quantity[hidden]')) input.value = input.min;
        var max = positiveInteger(option.dataset.quantityMax, null);
        if (max === null) input.removeAttribute('max');
        else input.max = String(max);
        normalizeQuantity(input);
      });
      if (!userChange) return;
      var mediaIndex = slides.findIndex(function (slide) {
        return option.dataset.mediaId && slide.dataset.mediaId === option.dataset.mediaId;
      });
      if (mediaIndex >= 0) showSlide(mediaIndex);
      var url = new URL(window.location.href);
      url.searchParams.set('variant', option.value);
      window.history.replaceState(window.history.state, '', url.href);
    }

    quantities.forEach(function (input) {
      input.addEventListener('change', function () { normalizeQuantity(input); }, { signal: signal });
    });
    if (variantSelect) {
      updateVariant(false);
      variantSelect.addEventListener('change', function () { updateVariant(true); }, { signal: signal });
    } else if (root.dataset.isComingSoon === 'true') {
      updateButtons(false);
    }

    if (sticky) {
      sticky.hidden = true;
      sticky.setAttribute('aria-hidden', 'true');
      if (form && 'IntersectionObserver' in window) {
        stickyObserver = new IntersectionObserver(function (entries) {
          var entry = entries[0];
          var visible = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          sticky.hidden = !visible;
          sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
        }, { threshold: 0 });
        stickyObserver.observe(form);
      }
    }
  }

  function initializeWithin(scope) {
    rootsWithin(scope).forEach(initialize);
  }

  if (!document[SECTION_EVENTS]) {
    document[SECTION_EVENTS] = true;
    document.addEventListener('shopify:section:load', function (event) {
      initializeWithin(event.target);
    });
    document.addEventListener('shopify:section:unload', function (event) {
      rootsWithin(event.target).forEach(function (root) {
        if (root[BOUND]) root[BOUND]();
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initializeWithin(document); }, { once: true });
  } else {
    initializeWithin(document);
  }
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wuyin-product"]) return;
  try {
    
(function () {
  'use strict';

  var ROOT_SELECTOR = '[data-wp-product]';
  var BOUND = Symbol.for('wuyin.product.bound');
  var SECTION_EVENTS = Symbol.for('wuyin.product.sectionEvents');

  function rootsWithin(scope) {
    var roots = Array.from(scope.querySelectorAll(ROOT_SELECTOR));
    if (scope.matches && scope.matches(ROOT_SELECTOR)) roots.unshift(scope);
    return roots;
  }

  function initialize(root) {
    if (root[BOUND]) return;
    var abort = new AbortController();
    var signal = abort.signal;
    root.addEventListener('click', function (event) {
      var link = event.target.closest('.wp-story-link, .wp-final-details');
      if (!link || !root.contains(link)) return;
      var target = document.getElementById(link.hash.slice(1));
      if (!target || !root.contains(target)) return;
      event.preventDefault();
      event.stopPropagation();
      if (link.classList.contains('wp-final-details')) {
        var details = target.querySelector('details');
        if (details) details.open = true;
      }
      target.scrollIntoView({ block: 'start', behavior: 'instant' });
    }, { signal: signal });
    var stickyObserver = null;
    root[BOUND] = function () {
      abort.abort();
      if (stickyObserver) stickyObserver.disconnect();
      delete root[BOUND];
    };

    var gallery = root.querySelector('[data-wp-gallery]');
    var slides = Array.from(root.querySelectorAll('.wp-slide[data-media-id]'));
    var indices = Array.from(root.querySelectorAll('[data-wp-index]'));
    var steps = Array.from(root.querySelectorAll('[data-wp-step]'));
    var counts = Array.from(root.querySelectorAll('[data-wp-count]'));
    var form = root.querySelector('[data-wp-form]');
    var variantSelect = form && form.querySelector('select[name="id"]');
    var quantities = Array.from(root.querySelectorAll('[data-wp-quantity]'));
    var submitButtons = Array.from(root.querySelectorAll('[data-wp-submit]'));
    var sticky = root.querySelector('[data-wp-sticky]');
    var dialog = root.querySelector('dialog[data-wp-dialog]');
    var dialogImage = dialog && dialog.querySelector('img');
    var returnFocus = null;
    var gesture = null;
    var suppressClickUntil = 0;
    var current = slides.findIndex(function (slide) {
      return slide.dataset.mediaId === root.dataset.initialMedia;
    });
    if (current < 0) current = slides.findIndex(function (slide) { return !slide.hidden; });
    if (current < 0) current = 0;

    function pauseSlide(slide) {
      slide.querySelectorAll('video').forEach(function (video) { video.pause(); });
      slide.querySelectorAll('iframe').forEach(function (frame) {
        var src = frame.getAttribute('src');
        if (!src || src === 'about:blank') return;
        var pausedURL = new URL(src, window.location.href);
        pausedURL.searchParams.set('autoplay', '0');
        frame.setAttribute('src', pausedURL.href);
      });
    }

    function showSlide(index) {
      if (!slides.length) return;
      var next = ((index % slides.length) + slides.length) % slides.length;
      if (next !== current) pauseSlide(slides[current]);
      current = next;
      slides.forEach(function (slide, slideIndex) {
        slide.hidden = slideIndex !== current;
        slide.setAttribute('aria-hidden', slideIndex === current ? 'false' : 'true');
      });
      indices.forEach(function (button) {
        button.setAttribute('aria-pressed', Number(button.dataset.wpIndex) === current ? 'true' : 'false');
      });
      var thumbnail = root.querySelector('.wp-thumbnail[aria-pressed="true"]');
      if (thumbnail && thumbnail.offsetWidth) {
        var strip = thumbnail.parentElement;
        var thumbnailRect = thumbnail.getBoundingClientRect();
        var stripRect = strip.getBoundingClientRect();
        if (window.getComputedStyle(strip).flexDirection === 'column') {
          strip.scrollTop += thumbnailRect.top - stripRect.top - (strip.clientHeight - thumbnailRect.height) / 2;
        } else {
          strip.scrollLeft += thumbnailRect.left - stripRect.left - (strip.clientWidth - thumbnailRect.width) / 2;
        }
      }
      counts.forEach(function (count) {
        count.textContent = String(current + 1) + ' / ' + String(slides.length);
      });
    }

    steps.forEach(function (button) {
      button.type = 'button';
      button.hidden = slides.length < 2;
      button.addEventListener('click', function () {
        showSlide(current + Number(button.dataset.wpStep));
      }, { signal: signal });
    });
    indices.forEach(function (button) {
      button.type = 'button';
      button.hidden = slides.length < 2;
      button.addEventListener('click', function () {
        showSlide(Number(button.dataset.wpIndex));
      }, { signal: signal });
    });
    counts.forEach(function (count) { count.hidden = slides.length < 2; });
    showSlide(current);

    if (gallery) {
      if (!gallery.hasAttribute('tabindex')) gallery.tabIndex = 0;
      gallery.style.touchAction = 'pan-y pinch-zoom';
      gallery.addEventListener('keydown', function (event) {
        if (event.altKey || event.ctrlKey || event.metaKey || slides.length < 2) return;
        if (event.target.closest('input, select, textarea, [contenteditable]:not([contenteditable="false"])')) return;
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        showSlide(current + (event.key === 'ArrowRight' ? 1 : -1));
      }, { signal: signal });

      gallery.addEventListener('dragstart', function (event) {
        if (event.target.closest('.wp-slide')) event.preventDefault();
      }, { signal: signal });

      gallery.addEventListener('pointerdown', function (event) {
        if (!slides.length || !event.isPrimary || event.button !== 0) return;
        var control = event.target.closest('button, a, input, select, textarea, video, iframe, [contenteditable]');
        if (control && !control.matches('[data-wp-zoom]')) return;
        gesture = { id: event.pointerId, type: event.pointerType, x: event.clientX, y: event.clientY, axis: null };
      }, { signal: signal });

      gallery.addEventListener('pointermove', function (event) {
        if (!gesture || event.pointerId !== gesture.id) return;
        var dx = event.clientX - gesture.x;
        var dy = event.clientY - gesture.y;
        if (!gesture.axis && Math.max(Math.abs(dx), Math.abs(dy)) > 12) {
          if (Math.abs(dx) > Math.abs(dy) * 1.3) {
            gesture.axis = 'x';
            gallery.setPointerCapture(event.pointerId);
          } else if (Math.abs(dy) > Math.abs(dx)) {
            gesture.axis = 'y';
          }
        }
        if (gesture.axis === 'x' && event.cancelable) event.preventDefault();
      }, { signal: signal, passive: false });

      function finishGesture(event) {
        if (!gesture || event.pointerId !== gesture.id) return;
        var completed = gesture;
        gesture = null;
        if (gallery.hasPointerCapture(event.pointerId)) gallery.releasePointerCapture(event.pointerId);
        var dx = event.clientX - completed.x;
        var dy = event.clientY - completed.y;
        if (completed.axis !== 'x') {
          if (completed.type === 'mouse' && Math.max(Math.abs(dx), Math.abs(dy)) > 12) {
            suppressClickUntil = Date.now() + 450;
          }
          return;
        }
        suppressClickUntil = Date.now() + 450;
        if (event.type === 'pointercancel') return;
        var threshold = Math.min(64, Math.max(36, gallery.clientWidth * 0.09));
        if (Math.abs(dx) >= threshold && Math.abs(dx) > Math.abs(dy) * 1.3) {
          showSlide(current + (dx < 0 ? 1 : -1));
        }
      }

      gallery.addEventListener('pointerup', finishGesture, { signal: signal });
      gallery.addEventListener('pointercancel', finishGesture, { signal: signal });
      gallery.addEventListener('click', function (event) {
        if (Date.now() >= suppressClickUntil) return;
        event.preventDefault();
        event.stopImmediatePropagation();
      }, { signal: signal, capture: true });
    }

    if (dialog && dialogImage) {
      root.querySelectorAll('[data-wp-zoom]').forEach(function (button) {
        if (button.tagName === 'BUTTON') button.type = 'button';
      });
      root.addEventListener('click', function (event) {
        var button = event.target.closest('[data-wp-zoom]');
        if (!button || !root.contains(button)) return;
        var source = button.dataset.zoomSrc;
        if (!source) return;
        event.preventDefault();
        returnFocus = button;
        dialogImage.src = source;
        dialogImage.alt = button.dataset.zoomAlt || '';
        if (!dialog.open) dialog.showModal();
        var closeButton = dialog.querySelector('[data-wp-close]');
        if (closeButton) closeButton.focus({ preventScroll: true });
      }, { signal: signal });
      dialog.querySelectorAll('[data-wp-close]').forEach(function (button) {
        button.type = 'button';
        button.addEventListener('click', function () { dialog.close(); }, { signal: signal });
      });
      dialog.addEventListener('click', function (event) {
        if (event.target === dialog) dialog.close();
      }, { signal: signal });
      dialog.addEventListener('close', function () {
        if (returnFocus && returnFocus.isConnected) returnFocus.focus({ preventScroll: true });
        returnFocus = null;
      }, { signal: signal });
    }

    function positiveInteger(value, fallback) {
      var parsed = Number(value);
      return Number.isFinite(parsed) && parsed > 0 ? Math.floor(parsed) : fallback;
    }

    function normalizeQuantity(input) {
      var min = positiveInteger(input.min, 1);
      var step = positiveInteger(input.step, 1);
      var max = input.max === '' ? Infinity : positiveInteger(input.max, Infinity);
      var value = positiveInteger(input.value, min);
      var increments = Math.max(0, Math.round((value - min) / step));
      if (Number.isFinite(max)) increments = Math.min(increments, Math.max(0, Math.floor((max - min) / step)));
      input.value = String(min + increments * step);
    }

    function updateButtons(available) {
      var comingSoon = root.dataset.isComingSoon === 'true';
      var label = comingSoon
        ? (root.dataset.comingSoonLabel || 'Coming soon')
        : available
          ? (root.dataset.addLabel || 'Add to bag')
          : (root.dataset.soldOutLabel || 'Sold out');
      submitButtons.forEach(function (button) {
        button.disabled = comingSoon || !available;
        var labelElement = button.querySelector('[data-wp-label]');
        if (labelElement) labelElement.textContent = label;
        else button.textContent = label;
        button.querySelectorAll('[data-wp-buy-price]').forEach(function (price) {
          price.hidden = comingSoon || !available;
        });
      });
    }

    function updateVariant(userChange) {
      if (!variantSelect) return;
      var option = variantSelect.options[variantSelect.selectedIndex];
      if (!option) return;
      if (option.dataset.material !== undefined) {
        root.querySelectorAll('[data-wp-material]').forEach(function (material) {
          material.textContent = option.dataset.material;
        });
      }
      root.querySelectorAll('[data-wp-price]').forEach(function (price) {
        if (option.dataset.price !== undefined) price.textContent = option.dataset.price;
      });
      if (option.dataset.priceAmount !== undefined) {
        root.querySelectorAll('[data-wp-price-amount], [data-wp-buy-amount]').forEach(function (amount) {
          amount.textContent = option.dataset.priceAmount;
        });
      }
      root.querySelectorAll('[data-wp-compare]').forEach(function (price) {
        var compare = option.dataset.compare || '';
        price.textContent = compare;
        price.hidden = compare.trim() === '';
      });
      updateButtons(option.dataset.available === 'true');
      quantities.forEach(function (input) {
        input.min = String(positiveInteger(option.dataset.quantityMin, 1));
        input.step = String(positiveInteger(option.dataset.quantityIncrement, 1));
        if (input.closest('.wp-quantity[hidden]')) input.value = input.min;
        var max = positiveInteger(option.dataset.quantityMax, null);
        if (max === null) input.removeAttribute('max');
        else input.max = String(max);
        normalizeQuantity(input);
      });
      if (!userChange) return;
      var mediaIndex = slides.findIndex(function (slide) {
        return option.dataset.mediaId && slide.dataset.mediaId === option.dataset.mediaId;
      });
      if (mediaIndex >= 0) showSlide(mediaIndex);
      var url = new URL(window.location.href);
      url.searchParams.set('variant', option.value);
      window.history.replaceState(window.history.state, '', url.href);
    }

    quantities.forEach(function (input) {
      input.addEventListener('change', function () { normalizeQuantity(input); }, { signal: signal });
    });
    if (variantSelect) {
      updateVariant(false);
      variantSelect.addEventListener('change', function () { updateVariant(true); }, { signal: signal });
    } else if (root.dataset.isComingSoon === 'true') {
      updateButtons(false);
    }

    if (sticky) {
      sticky.hidden = true;
      sticky.setAttribute('aria-hidden', 'true');
      if (form && 'IntersectionObserver' in window) {
        stickyObserver = new IntersectionObserver(function (entries) {
          var entry = entries[0];
          var visible = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          sticky.hidden = !visible;
          sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
        }, { threshold: 0 });
        stickyObserver.observe(form);
      }
    }
  }

  function initializeWithin(scope) {
    rootsWithin(scope).forEach(initialize);
  }

  if (!document[SECTION_EVENTS]) {
    document[SECTION_EVENTS] = true;
    document.addEventListener('shopify:section:load', function (event) {
      initializeWithin(event.target);
    });
    document.addEventListener('shopify:section:unload', function (event) {
      rootsWithin(event.target).forEach(function (root) {
        if (root[BOUND]) root[BOUND]();
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initializeWithin(document); }, { once: true });
  } else {
    initializeWithin(document);
  }
})();


  } catch(e) { console.error(e); }
})();
})();
